module.exports = __webpack_public_path__ + "static/media/android@2x.925352db.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/uq-ui/components/store-button/img/android@2x.png
// module id = 1117
// module chunks = 0